import Favourite from '../../../favourite/favourite.jsx';
import LastSavedDate from '../lastSavedDate.jsx';
import QueryName from '../query-name.jsx';
import Schedule from '../schedule.jsx';

export const STORED_CRITERIA_TABLE_HEADERS = [
   {
      field: 'isFavourite',
      headerName: 'FAV',
      headerTooltip: 'Favourite',
      cellRenderer: Favourite,
      type: 'editableColumn',
      width: 70,
   },
   {
      field: 'title',
      headerName: 'QUERY NAME',
      headerTooltip: 'Query Name',
      editable: true,
      cellRenderer: QueryName,
      width: 150,
   },
   {
      field: 'lastUpdatedAt',
      headerName: 'LAST SAVED DATE',
      headerTooltip: 'Last Saved Date',
      cellRenderer: LastSavedDate,
      width: 200,
   },
   {
      field: 'description',
      headerName: 'DESCRIPTION',
      headerTooltip: 'Description',
      type: 'editableColumn',
      editable: true,
      valueSetter: ({ newValue, data }) => data.description = newValue.toUpperCase(),
   },
   {
      field: 'userId',
      headerName: 'USER NAME',
      headerTooltip: 'User Name',
      width: 200,
   },
   {
      field: 'scheduleData',
      headerName: 'SCHEDULE',
      headerTooltip: 'Schedule',
      tooltipField: 'scheduleData',
      cellRenderer: Schedule,
   },
   {
      field: 'email',
      headerName: 'EMAIL',
      headerTooltip: 'Email',
   },
];
